import { type FC } from 'react';

import { ContactForm } from '@/components/ContactForm/ContactForm';
import { Column, Row } from '@/components/Grid';
import { WithGap } from '@/components/WithGap';
import { useTexts } from '@/hooks/useTexts';

import { useContactFormSource } from '../../hooks/useContactFormSource';
import { OrderForm } from './components/OrderForm';

export const OrderDetails: FC = () => {
  const { orders } = useTexts();
  const contactFormSource = useContactFormSource();

  return (
    <WithGap>
      <WithGap gap="24">
        <Row>
          <Column $span={9}>
            <ContactForm source={contactFormSource} />
          </Column>
        </Row>
        <h2 data-test="order-details-title">
          {orders.form.steps.orderDetails.title}
        </h2>
      </WithGap>

      <OrderForm />
    </WithGap>
  );
};
